import { axiosIntance } from "./config"

export const createEmployee = async(data)=>{
    const response = await axiosIntance.post('/employees',data)
    return response.data
}

export const getAllEmployee = async()=>{
    const response = await axiosIntance.get('/employees')
    return response.data
}

export const updateEmployee = async(id)=>{
    const response = await axiosIntance.put(`/employees/${id}`)
    return response.data
}

export const deleteEmployee = async(id)=>{
    const response = await axiosIntance.delete(`/employees/${id}`)
    return response.data
}